export enum FeatureLaunch {
  FILING_AUTOMATION_DEMO = 'FILING_AUTOMATION_DEMO',
  ComplianceMonitor = 'COMPLIANCE_MONITOR',
  MarketplaceTab = 'MARKETPLACE_TAB',
  USCorporationOnboarding = 'US_CORPORATION_ONBOARDING',
  INCorporationOnboarding = 'IN_CORPORATION_ONBOARDING',
  GBCorporationOnboarding = 'GB_CORPORATION_ONBOARDING',
  CACorporationOnboarding = 'CA_CORPORATION_ONBOARDING',
  SGCorporationOnboarding = 'SG_CORPORATION_ONBOARDING',
  AECorporationOnboarding = 'AE_CORPORATION_ONBOARDING',
  IECorporationOnboarding = 'IE_CORPORATION_ONBOARDING',
  NLCorporationOnboarding = 'NL_CORPORATION_ONBOARDING',
  ESCorporationOnboarding = 'ES_CORPORATION_ONBOARDING',
  ITCorporationOnboarding = 'IT_CORPORATION_ONBOARDING',
  FRCorporationOnboarding = 'FR_CORPORATION_ONBOARDING',
  LUCorporationOnboarding = 'LU_CORPORATION_ONBOARDING',
  BGCorporationOnboarding = 'BG_CORPORATION_ONBOARDING',
  PHCorporationOnboarding = 'PH_CORPORATION_ONBOARDING',
  CHCorporationOnboarding = 'CH_CORPORATION_ONBOARDING',
  VGCorporationOnboarding = 'VG_CORPORATION_ONBOARDING',
  MACorporationOnboarding = 'MA_CORPORATION_ONBOARDING',
  BECorporationOnboarding = 'BE_CORPORATION_ONBOARDING',
  UGCorporationOnboarding = 'UG_CORPORATION_ONBOARDING',
  KECorporationOnboarding = 'KE_CORPORATION_ONBOARDING',
  SKCorporationOnboarding = 'SK_CORPORATION_ONBOARDING',
  SICorporationOnboarding = 'SI_CORPORATION_ONBOARDING',
  NOCorporationOnboarding = 'NO_CORPORATION_ONBOARDING',
  RSCorporationOnboarding = 'RS_CORPORATION_ONBOARDING',
  TRCorporationOnboarding = 'TR_CORPORATION_ONBOARDING',
  PLCorporationOnboarding = 'PL_CORPORATION_ONBOARDING',
  AUCorporationOnboarding = 'AU_CORPORATION_ONBOARDING',
  DECorporationOnboarding = 'DE_CORPORATION_ONBOARDING',
  NZCorporationOnboarding = 'NZ_CORPORATION_ONBOARDING',
  MXCorporationOnboarding = 'MX_CORPORATION_ONBOARDING',
  BRCorporationOnboarding = 'BR_CORPORATION_ONBOARDING',
  CLCorporationOnboarding = 'CL_CORPORATION_ONBOARDING',
  COCorporationOnboarding = 'CO_CORPORATION_ONBOARDING',
  ARCorporationOnboarding = 'AR_CORPORATION_ONBOARDING',
  UYCorporationOnboarding = 'UY_CORPORATION_ONBOARDING',
  SECorporationOnboarding = 'SE_CORPORATION_ONBOARDING',
  PTCorporationOnboarding = 'PT_CORPORATION_ONBOARDING',
  JPCorporationOnboarding = 'JP_CORPORATION_ONBOARDING',
  ZACorporationOnboarding = 'ZA_CORPORATION_ONBOARDING',
  FJCorporationOnboarding = 'FJ_CORPORATION_ONBOARDING',
  CKCorporationOnboarding = 'CK_CORPORATION_ONBOARDING',
  IDCorporationOnboarding = 'ID_CORPORATION_ONBOARDING',
  KRCorporationOnboarding = 'KR_CORPORATION_ONBOARDING',
  SACorporationOnboarding = 'SA_CORPORATION_ONBOARDING',

  UPSELLS = 'UPSELLS',
  Settings = 'SETTINGS',
  IN_LLP_FORM = 'IN_LLP_FORM',
  SINGAPORE_INCORPORATION = 'SINGAPORE_INCORPORATION',
  INDIA_INCORPORATION = 'INDIA_INCORPORATION',
  US_INCORPORATION = 'US_INCORPORATION',
  UNITED_KINGDOM_INCORPORATION = 'UNITED_KINGDOM_INCORPORATION',
  BOOKKEEPING = 'BOOKKEEPING',
  ENTERPRISE_APP_SALES_TAX = 'ENTERPRISE_APP_SALES_TAX',
  SALES_TAX_ROOTFI_INTEGRATION = 'SALES_TAX_ROOTFI_INTEGRATION',
  SALES_TAX_ROOTFI_BILLS_SYNC = 'SALES_TAX_ROOTFI_BILLS_SYNC',
  SALES_TAX_EXEMPTIONS_TAB = 'SALES_TAX_EXEMPTIONS_TAB',
  US_INCORPORATION_CORPORATE_STAKEHOLDERS = 'US_INCORPORATION_CORPORATE_STAKEHOLDERS',
  ADMIN_AGENT_FIRMS_TAB = 'ADMIN_AGENT_FIRMS_TAB',
  GET_HELP_BUTTON = 'GET_HELP_BUTTON',
  SERVICE_REQUEST_SLA = 'SERVICE_REQUEST_SLA',
  SLA_CATEGORY_EXPORT = 'SLA_CATEGORY_EXPORT',
  RESPONSE_TIME_SLA = 'RESPONSE_TIME_SLA',
  SALES_TAX_FILINGS = 'SALES_TAX_FILINGS',
  REGISTRATION_AND_CREDENTIALS_TAB = 'REGISTRATION_AND_CREDENTIALS_TAB',
  ADD_DOCUMENTS_BUTTON = 'ADD_DOCUMENTS_BUTTON',
  SALES_TAX_FILING_TAX_DETAILS = 'SALES_TAX_FILING_TAX_DETAILS',
  PREPAID_COMPLIANCE_BILLING = 'PREPAID_COMPLIANCE_BILLING',
  TRANSFER_PRICING_DEMO = 'TRANSFER_PRICING_DEMO',
  AFFILIATE_TP_HARD_CODED_DEMO = 'AFFILIATE_TP_HARD_CODED_DEMO',
  AM_TP_DEMO = 'AM_TP_DEMO',
  /** The REAL AI surfaces on the affiliate console (chat, workflow builder). Distinct from
   * AM_TP_DEMO above, which gates the scripted storyboard tier. */
  A_AND_M_TP_DEMO = 'A_AND_M_TP_DEMO',
  TP_DOCUMENTATION_WORKFLOWS = 'TP_DOCUMENTATION_WORKFLOWS',
  /** The client and agent pickers on the affiliate chat composer. The agent picker sends a
   * `profile` on conversation create, which the backend rejects until that field ships: the global
   * ValidationPipe runs forbidNonWhitelisted, so this must not reach an env whose backend is older. */
  AFFILIATE_CHAT_PICKERS = 'AFFILIATE_CHAT_PICKERS',
  TRANSFER_PRICING_BENCHMARKING = 'TRANSFER_PRICING_BENCHMARKING',
  TRANSFER_PRICING_SERVER_FILTERS = 'TRANSFER_PRICING_SERVER_FILTERS',
  /** The TP Documents page. Needs the backend's `/transfer-pricing/documentation/kinds` and `/status` routes. */
  TRANSFER_PRICING_DOCUMENTS = 'TRANSFER_PRICING_DOCUMENTS',
  TP_DOCUMENTS_PREVIEW_FEATURES = 'TP_DOCUMENTS_PREVIEW_FEATURES',
  MARKETPLACE_SERVICES_REVAMP = 'MARKETPLACE_SERVICES_REVAMP',

  AFFILIATE_QUOTES_TAB = 'AFFILIATE_QUOTES_TAB',
  CUSTOM_FILINGS = 'CUSTOM_FILINGS',
  SALES_TAX_TRANSACTIONS_DETAIL_PAGE = 'SALES_TAX_TRANSACTIONS_DETAIL_PAGE',

  AGENT_SECURE_INFORMATION_REQUEST = 'AGENT_SECURE_INFORMATION_REQUEST',

  THREADS_AND_COMMENTS = 'THREADS_AND_COMMENTS',
  THREAD_SUBSCRIPTIONS = 'THREAD_SUBSCRIPTIONS',
  THREAD_FIRM_NAME_BADGE = 'THREAD_FIRM_NAME_BADGE',
  SALES_TAX_CHAT = 'SALES_TAX_CHAT',
  SERVICE_REQUEST_NPS_SURVEY = 'SERVICE_REQUEST_NPS_SURVEY',

  AFFILIATE_MARKETPLACE_SERVICES_TAB = 'AFFILIATE_MARKETPLACE_SERVICES_TAB',

  ENABLE_COUNTRIES_SELECTION_FOR_TAX_CALCULATION = 'ENABLE_COUNTRIES_SELECTION_FOR_TAX_CALCULATION',

  // Sales Tax Managed Registrations V2 - New onboarding tasks and simplified registration form
  SALES_TAX_MANAGED_REGISTRATIONS_V2 = 'SALES_TAX_MANAGED_REGISTRATIONS_V2',

  // Agent client access - allows agents to log into client enterprise accounts
  AGENT_CLIENT_ACCESS = 'AGENT_CLIENT_ACCESS',

  // Admin client access - allows Commenda admins to log into client enterprise accounts
  ADMIN_CLIENT_ACCESS = 'ADMIN_CLIENT_ACCESS',
  INDIRECT_TAX_UPLOAD_TRANSACTION_SERVICE_REQUEST = 'INDIRECT_TAX_UPLOAD_TRANSACTION_SERVICE_REQUEST',

  PRODUCT_CHANGELOG = 'PRODUCT_CHANGELOG',
  // Commenda OS Form Builder Fields - DSL-powered form components
  COMMENDA_OS_FORM_BUILDER = 'COMMENDA_OS_FORM_BUILDER',

  WORKFLOW_BUILDER_ENTERPRISE_APP = 'WORKFLOW_BUILDER_ENTERPRISE_APP',

  // New T&A onboarding via Workflow Builder / Form Builder (service request flow)
  TaNewOnboarding = 'TA_NEW_ONBOARDING',

  // Documents v2: Real folder hierarchy drive view with placements + tag filtering
  DocumentsV2DriveView = 'DOCUMENTS_V2_DRIVE_VIEW',
  GENERAL_THREAD = 'GENERAL_THREAD',

  // New accounting tab UI with rootfi integration (staging-only; prod shows old UI)
  ACCOUNTING_TAB_REVAMP = 'ACCOUNTING_TAB_REVAMP',

  INBOX_NAV = 'INBOX_NAV',
  CHAT_ROOM_PIN = 'CHAT_ROOM_PIN',

  // SYS_ROOTFI_SYNC workflow node (PRODUCT-2847). Gates the palette entry only —
  // runtime always recognises the step type once the DSL is deployed. Disabling
  // this flag does not break in-flight or saved workflows.
  ROOTFI_WORKFLOW_NODE = 'ROOTFI_WORKFLOW_NODE',

  // Calendar view toggle on the compliance monitor page
  COMPLIANCE_CALENDAR_VIEW = 'COMPLIANCE_CALENDAR_VIEW',

  // Surfaces the "Extend filing" / "Request for extension" actions across the
  // FilingsTable dropdown, the filing detail header, the calendar agenda kebab,
  // and the service-request page header. Staging-only while the backend matures.
  COMPLIANCE_EXTENSION = 'COMPLIANCE_EXTENSION',

  // Compliance calendar agenda widget on the enterprise home screen (replaces inbox)
  HOME_CALENDAR_AGENDA = 'HOME_CALENDAR_AGENDA',

  NEW_HOME_SCREEN = 'NEW_HOME_SCREEN',

  // V2 cap-table UI on /corporation/[id]/ownership; off shows legacy <Ownership>.
  OWNERSHIP_OVERHAUL = 'OWNERSHIP_OVERHAUL',

  // FY-N tab gate. Mirrors the backend `compliance_rule_engine` flag (default OFF / dark).
  ObligationRulesGenerator = 'COMPLIANCE_RULE_ENGINE',

  WORKFLOW_RESET_TO_STEP_ACTION = 'WORKFLOW_RESET_TO_STEP_ACTION',

  KEY_PERSONS = 'KEY_PERSONS',

  COMMENDA_SERVICES_LAYER = 'COMMENDA_SERVICES_LAYER',

  INDIRECT_TAX_TAX_CALCULATOR_BUTTON = 'INDIRECT_TAX_TAX_CALCULATOR_BUTTON',

  INDIRECT_TAX_LOCATIONS = 'INDIRECT_TAX_LOCATIONS',

  INDIRECT_TAX_CA_CONTRIBUTIONS = 'INDIRECT_TAX_CA_CONTRIBUTIONS',

  INDIRECT_TAX_FILING_APPROVAL_REQUEST = 'INDIRECT_TAX_FILING_APPROVAL_REQUEST',

  INDIRECT_TAX_REGISTRATION_WORKFLOW = 'INDIRECT_TAX_REGISTRATION_WORKFLOW',

  MCP_CHAT_NAV = 'MCP_CHAT_NAV',
  CHAT_PANEL = 'CHAT_PANEL',

  REGULATORY_UPDATES = 'REGULATORY_UPDATES',

  SCHEDULED_AGENTS = 'SCHEDULED_AGENTS',

  COMMENDA_MCP_ACCESS = 'COMMENDA_MCP_ACCESS',
  COMMENDA_BILLING = 'COMMENDA_BILLING',

  FORM_BUILDER_V2 = 'FORM_BUILDER_V2',

  NOTIFICATIONS_PLATFORM = 'NOTIFICATIONS_PLATFORM',

  // Read the billing page's subscriptions + invoices from Commenda's own mirror tables (Stripe-era) instead
  // of Chargebee. Part of the Chargebee→Stripe read cutover.
  BILLING_READ_FROM_MIRROR = 'BILLING_READ_FROM_MIRROR',
  FormExternalShare = 'FORM_EXTERNAL_SHARE',
  DOCUMENT_ASSEMBLER = 'DOCUMENT_ASSEMBLER',

  // Ad-hoc mode on the e-signature workflow node: sends a document produced during the run
  // (typically an upstream agent step's generated draft) instead of a pre-published template.
  // Gates authoring and the task's send flow. The backend accepts ad-hoc steps in every
  // environment, so a definition promoted from one where this is on still runs — but the task
  // will not offer to send until the flag reaches that environment too.
  ESIGN_AD_HOC_DOCUMENT = 'ESIGN_AD_HOC_DOCUMENT',

  ENTITY_EXISTING_DOCUMENT_PICKER = 'ENTITY_EXISTING_DOCUMENT_PICKER',

  CHAT_FOLDER_UPLOAD = 'CHAT_FOLDER_UPLOAD',

  CHAT_SAVE_GENERATED_FILES = 'CHAT_SAVE_GENERATED_FILES',
  AGENT_BULK_MESSAGING = 'AGENT_BULK_MESSAGING',

  // Workflow editor Draft auditor preset; the backend `service_auditor` flag is the real gate.
  SERVICE_AUDITOR = 'SERVICE_AUDITOR',
  ADMIN_SERVICE_DELIVERY_SAVED_VIEWS = 'ADMIN_SERVICE_DELIVERY_SAVED_VIEWS',
  MANAGEMENT_REPORTING = 'MANAGEMENT_REPORTING',
  MANAGEMENT_REPORT_COLUMN_LAYOUT = 'MANAGEMENT_REPORT_COLUMN_LAYOUT',
  MANAGEMENT_REPORT_INLINE_OVERRIDE = 'MANAGEMENT_REPORT_INLINE_OVERRIDE',
  SETTINGS_INTEGRATIONS_TAB = 'SETTINGS_INTEGRATIONS_TAB',
}
